// Configuration constants for Maturity Assessment module

export const SCORE_RELIABILITY_THRESHOLD = 0.80;
export const NA_ADVISORY_THRESHOLD = 0.15;

export const TIER_CONTROL_COUNTS = {
  T1: 34,
  T2: 71,
  T3: 84
};

export const TIER_BANNER = {
  T1: "Showing 34 foundational controls applicable to your organisation. Foundational controls apply to all organisation types.",
  T2: "Showing standard controls applicable to your organisation (Foundational + Standard tiers). Advanced controls are not included in your assessment scope.",
  T3: "Showing all 84 controls across all tiers. Your organisation is assessed against the full TR²UST framework."
};

// Maturity levels with descriptions (used by control page level selector)
export const MATURITY_LEVELS = [
  {
    level: 1,
    name: "Reactive",
    color: "#EF4444",
    desc: "No formal acknowledgment. Privacy treated as IT or legal problem only."
  },
  {
    level: 2,
    name: "Provisional",
    color: "#F59E0B",
    desc: "Informal acknowledgment but nothing documented. Resources unallocated."
  },
  {
    level: 3,
    name: "Formalized",
    color: "#10B981",
    desc: "Policy signed off, dedicated budget allocated, accountability documented in job descriptions."
  },
  {
    level: 4,
    name: "Monitored",
    color: "#3B82F6",
    desc: "Regular management review. KPIs tracked. Privacy in strategic planning."
  },
  {
    level: 5,
    name: "Proactive",
    color: "#8B5CF6",
    desc: "Privacy embedded in governance. Executive accountability. Board-level oversight."
  },
];

// Alias for backward compatibility
export const MATURITY_LEVELS_CONFIG = MATURITY_LEVELS;

// Maturity levels as object keyed by level (for quick lookup with styling)
export const MATURITY_LEVELS_MAP = {
  1: {
    name: 'Reactive',
    color: '#EF4444',
    bg: 'bg-red-500/10 dark:bg-red-500/20',
    text: 'text-red-600 dark:text-red-400'
  },
  2: {
    name: 'Provisional',
    color: '#F59E0B',
    bg: 'bg-amber-500/10 dark:bg-amber-500/20',
    text: 'text-amber-600 dark:text-amber-400'
  },
  3: {
    name: 'Formalized',
    color: '#10B981',
    bg: 'bg-emerald-500/10 dark:bg-emerald-500/20',
    text: 'text-emerald-600 dark:text-emerald-400'
  },
  4: {
    name: 'Monitored',
    color: '#3B82F6',
    bg: 'bg-blue-500/10 dark:bg-blue-500/20',
    text: 'text-blue-600 dark:text-blue-400'
  },
  5: {
    name: 'Proactive',
    color: '#8B5CF6',
    bg: 'bg-violet-500/10 dark:bg-violet-500/20',
    text: 'text-violet-600 dark:text-violet-400'
  }
};
